angular.module('rjmNg.controllers').controller('dashCloneCtrl', [
  "$scope"
  "$modal"
  "$http"
  "$location"
  "appRoute"
  "dashboardService"
  "app"
  "$url"
  ($scope, $modal, $http, $location, appRoute, dashboardService, app, $url) ->
    $scope.error = null
    $scope.search = null
    $scope.replace = null
    $scope.name = $scope.name
    $scope.id = $scope.id

    $scope.cloneDash = (modal) ->

      #do not allow empty names
      if $scope.name?.length is 0
        $scope.error = "Name must contain at least one character"
        return

      $http(
        method: 'POST'
        url: $url("/client/" + app.getClientId() + "/dashboard/" + $scope.id + "/saveas/")
        data: { name: $scope.name, search: $scope.search, replace: $scope.replace }
      )
      .then( ({data}) =>
        app.addDashboard(data)
        dashboardService.updateGlobalSearch()

        $location.path appRoute("/#{data.id}")
        $location.replace()

        modal('hide')
      )
      .catch( ({data}) =>
        $scope.error = data.error
      )
])
